import React from 'react';
import { AlertTriangle } from 'lucide-react';

const EarlyCheckoutBlockModal = ({ scheduledEnd, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl shadow-2xl max-w-md w-full p-8 animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-20 h-20 bg-amber-500/15 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-12 h-12 text-amber-400" />
          </div>
          
          <h2 className="text-2xl font-bold text-white mb-2">Cannot Check Out Yet</h2>
          
          <p className="text-zinc-400 mb-1">You are scheduled until</p>
          <p className="text-3xl font-bold text-amber-400 mb-6">{scheduledEnd}</p>
          
          <button
            onClick={onClose}
            data-testid="early-checkout-ok-btn"
            className="w-full bg-amber-500/15 hover:bg-amber-500/25 text-amber-200 ring-1 ring-amber-400/25 font-semibold py-3 px-6 rounded-xl transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default EarlyCheckoutBlockModal;
